const axios = require('axios')

function createInstance (authService, cacheConfig, cachios) {
  let axiosInstance = axios.create({})

  axiosInstance.interceptors.request.use(function (config) {
    config.headers['Authorization'] = authService.getAuthToken()
    return config
  }, function (error) {
    return Promise.reject(error)
  })

  axiosInstance.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    if (error.response.status === 401) {
      authService.logOut()
    }
    return Promise.reject(error)
  })

  return cachios.create(axiosInstance, cacheConfig)
}
export { createInstance as cachiosConfigure }



// WEBPACK FOOTER //
// ./src/services/axios/axiosConfigurer.js